import StepIndicator from "../../../UI/StepIndicator";
import FormNavigation from "../../../UI/FormNavigation";
import Step1InformacoesPessoais from "../Step1InformacoesPessoais";
import Step2InformacoesAcademicas from "../Step2InformacoesAcademicas";
import Step3DocumentacaoDigital from "../Step3DocumentacaoDigital";
import { useCompletarCadastro } from "./useCompletarCadastro";

export default function CompletarCadastroWizard() {
  const {
    currentStep,
    isLoading,
    step1Data,
    step1Errors,
    handleStep1Change,
    step2Data,
    step2Errors,
    handleStep2Change,
    step3FileNames,
    step3Errors,
    handleStep3Change,
    handleNext,
    handlePrevious,
    handleSubmit,
  } = useCompletarCadastro();

  const steps = [
    {
      number: 1,
      title: "Informações Pessoais",
      description: "Dados pessoais e contato",
    },
    {
      number: 2,
      title: "Acadêmico & Profissional",
      description: "Formação acadêmica",
    },
    {
      number: 3,
      title: "Anexo Documentação",
      description: "Upload de documentos",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-6 md:py-12">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8 md:mb-5">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 uppercase tracking-wide">
            Complete seu cadastro!
          </h1>
          <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto">
            Preencha todas as informações abaixo para finalizar seu cadastro e
            ter acesso completo aos editais da FAPITEC - Fundação de Apoio à
            Pesquisa e à Inovação Tecnológica do Estado de Sergipe
          </p>
        </div>

        <StepIndicator steps={steps} currentStep={currentStep} />

        <div className="bg-white rounded-lg shadow-lg p-6 md:p-10 mt-2 border border-gray-200">
          {currentStep === 1 && (
            <Step1InformacoesPessoais
              data={step1Data}
              errors={step1Errors}
              onChange={handleStep1Change}
            />
          )}
          {currentStep === 2 && (
            <Step2InformacoesAcademicas
              data={step2Data}
              errors={step2Errors}
              onChange={handleStep2Change}
            />
          )}
          {currentStep === 3 && (
            <Step3DocumentacaoDigital
              errors={step3Errors}
              onChange={handleStep3Change}
              fileNames={step3FileNames}
            />
          )}

          <FormNavigation
            currentStep={currentStep}
            totalSteps={3}
            onPrevious={handlePrevious}
            onNext={handleNext}
            onSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
